import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { Gruppe } from '../classes/gruppe';
import { EnterValueInput, EnterValueResponse } from '../../dialogs/enter-value-dialog/enter-value-response';
import { EnterValueDialogComponent } from '../../dialogs/enter-value-dialog/enter-value-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { KieneBackendApiService } from '../../../services/backend-api/kiene-backend-api.service';
import { API_BASE_URL_SERVICE } from '../../../kiene-core.config';
import { MessageService } from '../../../services/message-service/message.service';
import { Router } from '@angular/router';
import { AusstallenService } from '../../ausstallen/ausstallen.service';
import { ConfirmDialogInput, ConfirmDialogResult } from '../../dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../dialogs/confirm-dialog/confirm-dialog.component';
import { GruppenService } from '../../gruppen/gruppen.service';
import { EinstallenMeldenDialogInput, EinstallenMeldenDialogResult } from '../../gruppen/classes/einstallen-melden';
import { EinstallenMeldenDialogComponent } from '../../gruppen/gruppe-einstallen/einstallen-melden-dialog/einstallen-melden-dialog.component';
import { EinstallenService } from '../../gruppen/gruppe-einstallen/einstallen.service';
import { GruppeInformationenDialogComponent } from '../../gruppen/gruppe-kommentar-dialog/gruppe-informationen-dialog.component';
import { GruppeStandortWechselnDialogResult } from '../../gruppen/gruppe-standort-wechseln-dialog/gruppe-standort-wechseln-dialog-result';

import { GruppeStandortWechselnDialogComponent } from '../../gruppen/gruppe-standort-wechseln-dialog/gruppe-standort-wechseln-dialog.component';
import { GruppeTierService } from '../../gruppe-tier/gruppe-tier.service';
import { UmstallenDialogComponent } from '../schweine/umstallen-dialog/umstallen-dialog.component';
import { AusstallenDialogComponent } from '../schweine/ausstallen-dialog/ausstallen-dialog.component';
import { GruppeSchweinDialogInput } from '../schweine/gruppe-schweine-dialog/gruppe-schweine-dialog';
import { GruppeSchweineDialogComponent } from '../schweine/gruppe-schweine-dialog/gruppe-schweine-dialog.component';
import { TodMeldenDialogComponent } from '../schweine/tod-melden-dialog/tod-melden-dialog.component';
import { ZeitslotBuchenDialogComponent } from '../schweine/zeitslot-buchen-dialog/zeitslot-buchen-dialog.component';
import { GruppeTier } from '../../gruppe-tier/classes/gruppe-tier';

@Component({
    selector: 'kiene-gruppen-menu',
    templateUrl: './gruppen-menu.component.html',
    styleUrls: ['./gruppen-menu.component.scss'],
})
export class GruppenMenuComponent implements OnInit {
    @Input('gruppe') gruppe: Gruppe;
    @Input('historie') historie = false;
    @Input('selectedTiere') selectedTiere: GruppeTier[] = [];
    @Input('requireSelectedTiereForAusstallen') requireSelectedTiereForAusstallen = false;

    @Output('changed') changed = new EventEmitter<boolean>();

    constructor(
        private readonly dialog: MatDialog,
        private readonly api: KieneBackendApiService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly messageService: MessageService,
        private readonly router: Router,
        private readonly ausstallenService: AusstallenService,
        private readonly gruppenService: GruppenService,
        private readonly gruppeTierService: GruppeTierService,
        private readonly einstallenService: EinstallenService,
    ) {}

    ngOnInit(): void {}

    emitChange() {
        console.log('GruppeMenu: change happens');
        this.changed.emit(true);
    }

    bearbeiten() {
        if (this.gruppe.rind > 0) {
            this.bearbeitenRind();
        } else {
            this.bearbeitenSchwein();
        }
    }

    bearbeitenSchwein() {
        const input = new GruppeSchweinDialogInput(this.gruppe.kunde_id, this.gruppe.betriebsart_id, {
            gruppe: this.gruppe,
        });

        this.dialog
            .open<GruppeSchweineDialogComponent, GruppeSchweinDialogInput, Gruppe>(GruppeSchweineDialogComponent, {
                data: input,
            })
            .afterClosed()
            .subscribe({
                next: (gruppe: Gruppe) => {
                    if (gruppe) {
                        this.changed.emit(true);
                    }
                },
            });
    }

    bearbeitenRind() {
        const input = new EnterValueInput();
        input.title = 'Gruppennamen';
        input.text = 'Bitte geben Sie den Gruppennamen ein.';
        input.okButton = 'Speichern';
        input.buttonColor = 'accent';
        input.addInputValue('Gruppennamen', 'text', this.gruppe.bezeichnung);

        const dialogRef = this.dialog.open(EnterValueDialogComponent, { data: input });
        dialogRef.afterClosed().subscribe({
            next: (result: EnterValueResponse) => {
                if (result?.result) {
                    this.gruppe.bezeichnung = result.getValue(0);
                    this.api.updateGeneric(this.apiBaseUrl + 'gruppe/update.php', this.gruppe).subscribe({
                        next: () => {
                            this.messageService.infoMessage('Der Gruppenname wurde erfolgreich gespeichert!');
                            this.emitChange();
                        },
                        error: err => {
                            this.messageService.errorMessage('Fehler!', err);
                        },
                    });
                }
            },
        });
    }

    tiereHinzufuegen() {
        this.router.navigate(['/gruppen/tierehinzufuegen', this.gruppe.gruppe_id.toString()]).then();
    }

    ausstallen() {
        if (this.gruppe?.rind > 0) {
            const selectedTiere = this.requireSelectedTiereForAusstallen ? this.selectedTiere : undefined;
            this.ausstallenService.ausstallen(this.gruppe, false, selectedTiere);
        } else {
            this.dialog
                .open(AusstallenDialogComponent, { width: '100%', data: this.gruppe })
                .afterClosed()
                .subscribe({
                    next: (result: boolean) => {
                        if (result === true) {
                            this.changed.emit(true);
                        }
                    },
                });
        }
    }

    umstallen() {
        if (this.gruppe?.rind > 0) {
            this.ausstallenService.ausstallen(this.gruppe, false, undefined);
        } else {
            this.dialog
                .open(UmstallenDialogComponent, { width: '95vw', data: this.gruppe })
                .afterClosed()
                .subscribe({
                    next: (result: boolean) => {
                        if (result === true) {
                            this.changed.emit(true);
                        }
                    },
                });
        }
    }

    schlachten() {
        this.dialog
            .open(ZeitslotBuchenDialogComponent, { width: '100vw', height: '95vh', data: this.gruppe })
            .afterClosed()
            .subscribe({
                next: (result: boolean) => {
                    if (result === true) {
                        this.changed.emit(true);
                    }
                },
            });
    }

    todmeldung() {
        this.dialog
            .open(TodMeldenDialogComponent, { width: '95vw', data: this.gruppe })
            .afterClosed()
            .subscribe({
                next: (result: boolean) => {
                    if (result === true) {
                        this.changed.emit(true);
                    }
                },
            });
    }

    standortwechsel() {
        this.dialog
            .open(GruppeStandortWechselnDialogComponent, { data: { gruppe: this.gruppe } })
            .afterClosed()
            .subscribe({
                next: (result: GruppeStandortWechselnDialogResult) => {
                    if (result && result.confirm) {
                        this.emitChange();
                    }
                },
            });
    }

    ausstalllistenAnzeigen() {
        this.router.navigate(['/gruppen/abgang', this.gruppe.gruppe_id]).then();
    }

    tiereNachladen() {
        const input = new ConfirmDialogInput();
        input.headline = 'Tiere aus HIT laden';
        input.text = 'Sollen Tiere im angegeben Einstallzeitraum in HIT gesucht werden?';
        input.okButton = 'Tiere laden';

        const dialogRef = this.dialog.open(ConfirmDialogComponent, { width: '50%', minWidth: '300px', data: input });

        dialogRef.afterClosed().subscribe({
            next: (result: ConfirmDialogResult) => {
                if (result?.confirmed) {
                    const snackbarRef = this.messageService.infoMessage(
                        'Tiere werden aus HI-Tier geladen. Dies kann einen Moment dauern.',
                    );
                    this.gruppenService.tiereAusHitNachladen(this.gruppe).subscribe({
                        next: () => {
                            //snackbarRef?.dismiss();
                            this.messageService.infoMessage('Tiere wurden erfolgreich aus HI-Tier nachgeladen!');
                            this.emitChange();
                        },
                        error: err => {
                            //snackbarRef?.dismiss();
                            this.messageService.errorMessage('Fehler!', err);
                        },
                    });
                }
            },
        });
    }

    abgaengeMelden() {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                okButton: 'Melden',
                text: 'Sollen alle Tiere bei HI-Tier abgemeldet werden, die sich in einer abgeschlossenen Tierliste befinden?',
                headline: 'Abgänge melden',
                buttonColor: 'accent',
            },
        });
        dialogRef.afterClosed().subscribe((resp: ConfirmDialogResult) => {
            if (resp?.confirmed) {
                this.api.updateGeneric(this.apiBaseUrl + 'gruppe_tier/abgaenge_hit.php', this.gruppe).subscribe({
                    next: () => {
                        this.messageService.infoMessage('Tiere werden bei HIT abgemeldet!');
                        this.emitChange();
                    },
                    error: err => {
                        this.messageService.errorMessage('Tiere können nicht abgemeldet werden!', err);
                    },
                });
            }
        });
    }

    zugaengeMelden() {
        this.einstallenService.clearCurrentEinstallTierlisteId();
        this.einstallenService.clearLastScanErgebnisse();
        this.einstallenService.clearPendingGewichte();

        const input = new EinstallenMeldenDialogInput();
        input.gruppe_id = this.gruppe?.gruppe_id;
        input.wholeGroup = true;

        const dialogRef = this.dialog.open(EinstallenMeldenDialogComponent, {
            width: '90vw',
            minWidth: '90vw',
            data: input,
        });
        dialogRef.afterClosed().subscribe({
            next: (result: EinstallenMeldenDialogResult) => {
                if (result?.ok) {
                    this.emitChange();
                }
            },
        });
    }

    zertifikateAnSGS() {
        this.gruppenService.zertifikateAnSGS({ ganzeGruppe: { gruppe_id: this.gruppe?.gruppe_id } });
    }

    openGruppeInformationen() {
        const dialogRef = this.dialog.open(GruppeInformationenDialogComponent, {
            width: '90vw',
            data: { gruppe_id: this.gruppe.gruppe_id },
        });
        dialogRef.afterClosed().subscribe({
            next: result => {
                if (result) {
                    this.emitChange();
                }
            },
        });
    }

    csvExport() {
        // const url = this.apiBaseUrl + 'gruppe_tier/read_csv.php';
        // const params = new HttpParams().set('gruppe_id', this.gruppe?.gruppe_id.toString());
        // const filename = 'Tiere Gruppe ' + this.gruppe.bezeichnung + '.csv';
        // this.csvDownloadService.downloadCsv(url, params, filename);
        this.gruppenService.exportCSV(this.gruppe, true);
    }

    excelExport() {
        this.gruppenService.exportExcel(this.gruppe, true);
    }

    reklamationenPdfDownload() {
        this.gruppenService.openReklamationPdfDialog(this.gruppe);
    }

    abgaengePdfDownload() {
        this.gruppenService.openGruppeAbgangDownloadDialog({ gruppe: this.gruppe });
    }

    gruppeInHistorie() {
        const input = new ConfirmDialogInput();
        input.headline = 'Gruppe in die Historie verschieben?';
        input.text = `Möchten Sie die Gruppe ${this.gruppe?.bezeichnung} wirklich in die Historie schieben?`;
        input.okButton = 'Verschieben';
        this.gruppeHistorieAendern(input, true);
    }

    gruppeAusHistorie() {
        const input = new ConfirmDialogInput();
        input.headline = 'Gruppe aus der Historie holen?';
        input.text = `Möchten Sie die Gruppe ${this.gruppe?.bezeichnung} wirklich wieder nach "aktuelle Gruppen" verschieben?`;
        input.okButton = 'Verschieben';
        this.gruppeHistorieAendern(input, false);
    }

    gruppeHistorieAendern(input: ConfirmDialogInput, historie: boolean) {
        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (result: ConfirmDialogResult) => {
                    if (result?.confirmed) {
                        this.gruppenService.historieAendern(this.gruppe, historie).subscribe({
                            next: () => {
                                this.messageService.infoMessage('Die Gruppe wurde erfolgreich verschoben!');
                                this.changed.emit(true);
                            },
                            error: err => {
                                this.messageService.errorMessage('Die Gruppe konnte nicht verschoben werden!', err);
                            },
                        });
                    }
                },
            });
    }

    deleteGruppe() {
        const input = new ConfirmDialogInput();
        input.headline = 'Gruppe unwiderruflich löschen?';
        input.text = `Möchten Sie die Gruppe ${this.gruppe?.bezeichnung} wirklich löschen?`;
        input.okButton = 'Löschen';

        const dialogRef = this.dialog.open(ConfirmDialogComponent, { data: input });

        dialogRef.afterClosed().subscribe({
            next: (result: ConfirmDialogResult) => {
                if (result?.confirmed) {
                    this.gruppenService.deleteGruppe(this.gruppe).subscribe({
                        next: () => {
                            this.messageService.infoMessage('Die Gruppe wurde erfolgreich gelöscht!');
                            this.changed.emit(true);
                        },
                        error: err => {
                            this.messageService.errorMessage('Die Gruppe konnte nicht gelöscht werden!', err);
                        },
                    });
                }
            },
        });
    }

    public ohrmarkenGescanntMarkieren() {
        this.gruppeTierService.ohrmarkeAlsGescanntMarkieren(this.gruppe?.gruppe_id, null).subscribe({
            next: (b: boolean) => {
                if (b) {
                    this.emitChange();
                }
            },
        });
    }
}
